


export const PAYMENT_ENDPOINTS = {
  STATUS: { path: `/payments/status`, method: "GET" },

  CREATE_PAYMENT_LINK: { path: `/payments/createpaymentlink`, method: "POST" },
  HAS_PAYMENT_LINK: { path: `/payments/haspaymentlink`, method: "GET" },
  PAY_NOW: { path: `/payments/pay`, method: "GET" },
  PAYMENT_CALLBACK: { path: `/payments/callback`, method: "GET" },
  WEBHOOK: { path: `/payments/webhook`, method: "POST" },
  GET_BY_ENTITY: { path: `/payments/entity`, method: "GET" },

  ADMIN_GET_ALL_PAYMENTS: {
    path: `/payments/admin/getallpayments`,
    method: "GET",
  },
};